import { getButtonOverridesLight as d, getButtonOverridesDark as n, MuiIconButtonOverridesDark as l, MuiButtonOverridesLight as u, MuiButtonOverridesDark as a } from "./buttons.js";
import { PaletteLight as o } from "./palette.js";
import t from "./shadows.js";
const c = "0.4rem", s = "3.6rem", m = "3rem", h = (r, i) => {
  const e = i === "light" ? d() : n();
  return {
    MuiBackdrop: {
      styleOverrides: {
        root: {
          "&:not(.MuiBackdrop-invisible)": {
            backgroundColor: "rgba(0, 0, 0, 0.7)"
          }
        }
      }
    },
    MuiButton: {
      styleOverrides: i === "light" ? u(r) : a(r)
    },
    MuiButtonGroup: {
      styleOverrides: {
        contained: {
          boxShadow: "none"
        },
        groupedContainedPrimary: e.containedPrimary,
        groupedContainedSecondary: e.containedSecondary,
        groupedOutlined: {
          backgroundColor: o.common.white,
          color: o.primary[500],
          borderColor: o.primary[500],
          "&:hover": {
            color: o.primary[400],
            borderColor: o.primary[400],
            backgroundColor: o.common.white
          },
          "&:disabled": {
            color: o.grey[400],
            borderColor: o.grey[100]
          }
        },
        groupedOutlinedPrimary: e.outlinedPrimary,
        groupedOutlinedSecondary: e.outlinedSecondary
      }
    },
    MuiCheckbox: {
      defaultProps: {
        color: "primary"
      },
      styleOverrides: {
        colorPrimary: {
          "&.MuiCheckbox-indeterminate:not(.Mui-disabled)": {
            color: o.primary[500]
          },
          "&.Mui-disabled": {
            color: o.grey[500]
          }
        },
        colorSecondary: {
          "&.MuiCheckbox-indeterminate:not(.Mui-disabled)": {
            color: o.secondary[500]
          },
          "&.Mui-disabled": {
            color: o.grey[500]
          }
        },
        root: {
          "&:not(.Mui-checked):not(.Mui-disabled)": {
            color: o.text.primary
          },
          "&.Mui-disabled": {
            color: o.grey[500]
          }
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        root: {
          ...r.componentXs,
          borderRadius: "24px",
          fontWeight: r.fontWeightBold
        }
      }
    },
    MuiIconButton: {
      styleOverrides: i === "light" ? void 0 : l
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          color: o.text.secondary,
          "&::placeholder": {
            ...r.componentItalicS,
            color: o.text.hint,
            opacity: 1,
            transition: "none"
          }
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          ...r.componentUppercaseXs,
          paddingBottom: 8
        }
      }
    },
    MuiMenu: {
      styleOverrides: {
        list: {
          paddingTop: 5,
          paddingBottom: 5,
          boxShadow: t[1]
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          lineHeight: r.componentS.lineHeight,
          height: m,
          "&:hover": {
            backgroundColor: o.grey[100]
          }
        }
      }
    },
    MuiRadio: {
      defaultProps: {
        color: "primary"
      }
    },
    MuiPaper: {
      styleOverrides: {
        outlined: {
          border: `1px solid ${o.grey[200]}`
        },
        rounded: {
          borderRadius: "0.5rem"
        }
      }
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          borderRadius: c,
          cursor: "pointer",
          height: s
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        colorAction: {
          color: o.warning[400]
        },
        root: {
          fontSize: "2.4rem"
        }
      }
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          "& > tr:nth-child(odd)": {
            backgroundColor: o.grey[20]
          }
        }
      }
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: o.grey[100]
        }
      }
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: r.componentXs.fontSize,
          lineHeight: r.componentXs.lineHeight,
          color: o.text.primary,
          backgroundColor: o.common.white,
          borderRadius: "0.5rem",
          padding: "1rem",
          boxShadow: t[1],
          borderColor: o.grey[100],
          borderStyle: "solid",
          borderWidth: "0.2rem",
          maxWidth: "28rem",
          whiteSpace: "break-spaces"
        },
        arrow: {
          color: o.common.white,
          fontSize: r.componentXl.fontSize,
          "&:before": {
            boxShadow: t[1],
            borderColor: o.grey[100],
            borderStyle: "solid",
            borderWidth: "0.2rem",
            boxSizing: "border-box"
          }
        }
      }
    }
  };
};
export {
  h as default
};
//# sourceMappingURL=components.js.map
